import type { ReactNode } from 'react';

interface DetailCardProps {
  title: ReactNode;
  action?: ReactNode;
  children: ReactNode;
}

const DetailCard = ({ title, action, children }: DetailCardProps) => (
  <div className='w-full p-5 bg-white rounded-lg shadow-md flex flex-col gap-3'>
    <div className='flex flex-wrap items-center justify-between gap-3'>
      <h3 className='text-gray-800 font-semibold'>{title}</h3>
      {action}
    </div>
    {children}
  </div>
);

export default DetailCard;
